import React, { useEffect, useState } from "react";
import Select from "react-select";
import { DropDown, RadioContainer } from "../../commons";
import { connect } from "react-redux";
import { RootState } from "../../../redux/rootReducers";
import { ClientType, LoginResponseType } from "../../../redux/auth/authTypes";
import { getJobsListAction } from "../../../redux/jobs";
import { SCHEDULING_USER_VIEW_OPTIONS } from "../../../constant/scheduling";
import { RADIO_OPTIONS } from "../../../utils/invoiceGeneration";
import { getAssignedClientsToUserAction } from "../../../redux/auth";
import { GetAssignedClientsToUserPayloadType } from "../../../commonTypes/authTypes";
export type DropDownItemType = {
  value: number | undefined;
  label: string | undefined;
};
type AppProps = {
  clientList: ClientType[] | [];
  type?:string;
  token: string | null;
  loginData: LoginResponseType;
  notificationRedirectClientCode?: string | null;
  notificationRedirectClientName?: string | null;
  notificationRedirectJobType?: string | null;
  dispatchGetClientsActiveJobAction: (data: any) => void;
  handleSubmitData?: (data: any) => void;
  dispatchGetAssignedClientsToUserAction: (data: GetAssignedClientsToUserPayloadType) => void;

};
const UserViewListngHeader = ({
  clientList,
  type,
  token,
  dispatchGetClientsActiveJobAction,
  handleSubmitData,
  loginData,
  notificationRedirectClientCode,
  notificationRedirectClientName,
  notificationRedirectJobType,
  dispatchGetAssignedClientsToUserAction
}: AppProps) => {
  const [finalClientList, setFinalClientList] = useState<
    DropDownItemType[] | []
  >([]);
  const [clientSelected, setClientSelected] = useState<any>({
    value: null,
    label: "Select Client",
  });
  const [jobShow, setJobShow] = useState(SCHEDULING_USER_VIEW_OPTIONS[1]?.id);
  const [offset, setOffset] = useState<number>(0);
  const [text, setText] = useState<string>("");
  const [limit, setLimit] = useState<number>(20);

  useEffect(() => {

    // dispatchResetFinacUsersList();
    const finalData = {
      token,
      user_id: loginData?.user_id
    }
    dispatchGetAssignedClientsToUserAction(finalData)
    if(notificationRedirectClientCode && notificationRedirectClientName&&notificationRedirectJobType){
      const data={
        value:notificationRedirectClientCode,
        label:notificationRedirectClientName
      }
      setJobShow(notificationRedirectJobType==="future_job"?"future_jobs":notificationRedirectJobType==="current_job"?"open_jobs":"")
      setClientSelected(data)
    }
  }, [])


  useEffect(() => {
    if (clientList?.length) {
      let finalClientData = clientList?.map((client: ClientType) => {
        return {
          value: client?.client_code,
          label: `(${client?.client_code})  ${client?.company_name}`,
        };
      });

      setFinalClientList(finalClientData);
    }
  }, [clientList]);

  const handleChangeClient = (client: any) => {
    setClientSelected(client);
  };
  const handleSetRadioValue = (radioValue: string) => {
    setJobShow(radioValue);
  };
  const handleSubmit = () => {
    const finaldata = {
      jobShow,
      clientSelected,
      offset,
      limit,
    };
    handleSubmitData?.(finaldata);
  };
  return (
    <div className="d-flex align-items-start">
      <div className="col-md-2 pl-3 form-group d-flex flex-column p-0">
        <DropDown
          placeholder="Choose Client.."
          options={finalClientList}
          handleChange={handleChangeClient}
          value={clientSelected}
        />
      </div>
      { type !=="clientVsUser"?
      <div className=" pl-3 pr-3 pt-2 p-0">
        <RadioContainer
          optionsList={SCHEDULING_USER_VIEW_OPTIONS}
          handleSetRadioValue={handleSetRadioValue}
          radioValue={jobShow}
          alignment="horizontal"
        />
      </div>:""}

      <div className="ml-3">
        <button
          className="btn btn-primary pl-3 pb-2"
          disabled={!clientSelected?.value}
          onClick={handleSubmit}
        >
          Apply
        </button>
      </div>
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  token: state.auth.token,
  clientList: state.auth.assignedClientsToUserList,
  loginData: state.auth.loginData,
  jobTrackerListing: state.jobs.jobsList,
  approvalMessage: state.disbursements.approvalMessage,
  fetching: state.disbursements.fetching,
  success: state.disbursements.success,
  finacUsersList: state.auth.finacUsersList,
  userFetching: state.auth.fetching,
});
const mapDispatchToProps = (dispatch: any) => ({
  dispatchGetClientsActiveJobAction: (data: any) =>
    dispatch(getJobsListAction(data)),
  dispatchGetAssignedClientsToUserAction: (data: GetAssignedClientsToUserPayloadType) =>
    dispatch(getAssignedClientsToUserAction(data))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UserViewListngHeader);
